import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useHistory, useLocation } from 'react-router';
import RouteUtils from '../../../modules/routeUtils';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './TermSearch.module.postcss';

function TermSearch({ isMobile = false, className }) {
  const history = useHistory();
  const location = useLocation();
  const { vehicle_type } = useContext(ConfigContext);
  const [value, setValue] = useState(null);

  // Prefill query from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get('query') || '';
    setValue(query);
  }, [location.search]);

  const handleChange = (val) => {
    setValue(val);
  };

  const onSubmit = () => {
    RouteUtils.updateQueryParam(
      history,
      location,
      { query: value, page: null },
      '/search'
    );
  };

  const onClear = () => {
    handleChange(null);
    RouteUtils.updateQueryParam(
      history,
      location,
      { query: null, page: null },
      '/search'
    );
  };

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      if (isMobile) return;
      onSubmit();
    }
  };

  return (
    <>
      <div
        className={cn(styles.TermSearch, className, {
          [styles.TermSearch_mobile]: isMobile,
        })}
      >
        <img src='/static/images/search.svg' alt='Search' width='15' height='16' />
        <input
          onChange={e => handleChange(e.target.value)}
          onKeyUp={onKeyUp}
          placeholder='Search by name or cuisine'
          value={value || ''}
        />
        { !!value &&
          <span onClick={onClear}>
            <img src='/static/images/admin/x-black.svg' alt='Toggle Search' width='10' height='10' />
          </span>
        }
      </div>

      { isMobile &&
        <button
          type='submit'
          className={cn(styles.TermSearch_Submit, 'Button u-mt1')}
          onClick={onSubmit}
        >
          Find {vehicle_type.toLowerCase()}s!
        </button>
      }
    </>
  );
}

TermSearch.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};

export default TermSearch;
